// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18RNq","title":"Header_title__3deLH","left":"Header_left__1slQ-","clinicName":"Header_clinicName__1RI2C"};